import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-view-layout',
  templateUrl: './mobile-view-layout.component.html',
  styleUrls: ['./mobile-view-layout.component.css'],
})
export class MobileViewLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
